import { Component, input } from '@angular/core';
import { SkeletonComponent } from '@shared/components/skeleton/skeleton.component';

@Component({
  selector: 'app-form-skeleton',
  imports: [SkeletonComponent],
  templateUrl: './form-skeleton.component.html',
})
export class FormSkeletonComponent {
  rows = input.required<number>();
  rowGap = input.required<number>();
  height = input<number>();

  get formattedRowGap() {
    return `${this.rowGap()}px`;
  }

  get formattedHeight() {
    return `${this.height() || 24}px`;
  }
}
